import React, { useState } from "react";
import { Validation } from "../../../../_helpers/validation/Validation";
import Button from "../CommonComponents/Button";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import InputMobileNumber from "../CommonComponents/InputMobileNumber";
import InputText from "../CommonComponents/InputText";
import { userDetail } from "./constant";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import style from "./style.module.css";
import { HomePageServices } from "../../../../_services/Arya2.0/HomePageServices";
import Loader from "../CommonComponents/Loader/Loader";
import { customToastr } from "../CustomToastr";
import { isNumberOnly } from "../CommonFunctions/Function";
import { URL_CONFIG } from "../../../../_constants/Config/URL_CONFIG";
import HeadLinesSpan from "../CommonComponents/HeadlinesSpan";
import { eventTracker } from "../GATracker3.0/eventTracker";
import { CALL_BACK_BANNER } from "../GATracker3.0/constants";
import ReCAPTCHA from "react-google-recaptcha";
import ValidationError from "../CommonComponents/ValidationError/ValidationError";
import { captchaKey } from "../../../../_constants/Config/AryaConstants";
import useIsUserLoggedIn from "../CustomHooks/useIsUserLoggedIn";
const initiate = {
  name: "",
  number: "",
  captchaToken: "",
};
const GetInTouchDesktop = ({ titleText = "Get in touch with arya.ag" }) => {
  const { t: translation } = useTranslation();
  const [data, setData] = useState(initiate);
  const [apiSuccess, setApiSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  let [userLoggedIn] = useIsUserLoggedIn();
  const location = useLocation();
  const onChange = (e) => {
    const { name, value } = e.target;
    const isNumberValid = value ? isNumberOnly(value) : true;

    if (name === "name" || (value.toString().length <= 10 && isNumberValid)) {
      setData((prev) => ({ ...prev, [name]: value }));
    }
  };
  const captchChange = (value) => {
    setError((prev) => ({
      ...prev,
      ["captchaToken"]: "",
    }));
    setData((prev) => ({ ...prev, ["captchaToken"]: value }));
  };

  const onExpired = (value) => {
    setData((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };
  const onSubmit = async () => {
    let errobj = {};
    errobj = Validation(data, userDetail());
    if (!userLoggedIn && !data?.captchaToken) {
      errobj.captchaToken =
        "Please check the box indicating 'I am not a robot' to submit your application";
    }
    setError(errobj);
    let flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      let registerdata = {
        first_name: data.name,
        phone_number: data.number,
        captcha_token: data.captchaToken,
      };
      setIsLoading(true);
      const result = await HomePageServices.getCallBack(registerdata);
      if (result && result.status_code === 200) {
        eventTracker("event", CALL_BACK_BANNER, {
          pagename: location.pathname === "/" ? "homepage" : location.pathname,
          addinfo: registerdata.first_name?.length
            ? "name+phone filled"
            : "phone filled",
        });
        // toastr.info("Request submitted");
        customToastr({
          text: "Thanks, we will get in touch soon",
        });
        setApiSuccess(true);
      }
      setIsLoading(false);
    }
  };
  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      {!apiSuccess && (
        <div className="d-flex padding-left-right100 top-bottom-margin-40">
          <img
            src={URL_CONFIG.IMG_URL + "arya2/getintouch.png"}
            className={`width-50 flex50 ${style["borderRadiusLeft"]}`}
            alt=""
          />
          <Card
            className={` ${style["borderRadiusRight"]} width-100  flex50   ${style["backDropFilters"]}`}
          >
            <div className="margin16 padding16">
              <HeadLines
                className="padding-bottom8 font-weight500 font-size24 line-height28 colorDark5"
                text={titleText}
              />
              <HeadLines
                className="font-weight400 font-size18 line-height21 letterSpacing05 colorDark7 padding-bottom16"
                text="Our representative will reach out to you to share some more information."
              />
              <div className="d-flex margin-top8">
                <div className="width-100">
                  <HeadLines
                    className="padding-bottom4"
                    text={
                      <>
                        <HeadLinesSpan
                          className={
                            "font-weight600 padding-bottom4 font-size14 line-height16 letterSpacing05 colorDark9"
                          }
                          text="Your Name"
                        />
                        &nbsp;
                        <HeadLinesSpan
                          className="font-weigh400 padding-bottom4 font-size14 line-height16 letterSpacing05 colorDark9 "
                          text={"(Optional)"}
                        />
                      </>
                    }
                  />
                  <InputText
                    className={`padding12 placeholderColorb8bdbd boxRadius8 width-100 font-weight400 font-size16 line-height19 letterSpacing05 ${
                      data.name ? "colorDark1" : "colorSecondary8"
                    }`}
                    placeholder="eg. Deepak Saxena"
                    value={data.name}
                    onChange={onChange}
                    name="name"
                    // showError={error.name}
                  />
                </div>
                <div className="width-100 margin-left20">
                  <HeadLines
                    className="font-weight600 font-size14 line-height16 letterSpacing05 colorDark9 padding-bottom4"
                    text="Your Contact Number"
                  />
                  <InputMobileNumber
                    className1={`padding-top12 placeholderColorb8bdbd padding-bottom12 ${style["padding-left50"]} boxRadius8 width-100 font-weight400 font-size16 line-height19 letterSpacing05 colorDark1`}
                    className2={`colorDark1 ${style["positionTopBottom"]}`}
                    value={data.number}
                    onChange={onChange}
                    name="number"
                    showError={translation(error.number)}
                  />
                </div>
              </div>
              {!userLoggedIn && (
                <div className="margin-top16">
                  <ReCAPTCHA
                    sitekey={captchaKey}
                    onChange={captchChange}
                    onExpired={onExpired}
                  />
                  {error.captchaToken && (
                    <ValidationError
                      text={error.captchaToken}
                      imageClassName={style["width-18"]}
                      textClassName={style["input-error-style-radio"]}
                    />
                  )}
                </div>
              )}
              <div className="d-flex justify-content-center margin-top24">
                <Button
                  className={`${style["backgroundColorRadius"]} ${style["width300"]} margin-top16 textColorWhite padding12 width-100 font-weight400 font-size16 line-height19 letterSpacing0125 `}
                  title="Get a Callback"
                  onClick={onSubmit}
                />
              </div>
            </div>
          </Card>
        </div>
      )}
    </>
  );
};
export default GetInTouchDesktop;
